import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import InputField from 'Components/Input/InputField';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';

const FilterItemCost = ({
    showFilterMonthPanelItem,
    isActiveFilterItems,
    comboBoxYear,
    onUpdateShowFilterMonthPanelItem,
    onUpdateIsActiveFilterItems,
    onUpdateComboBoxYear
}) => {

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center'
    }

    const styleRowsAttributes = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        margin: '10px'
    }

    const handleCheckboxChangeIeActiveValue = (value) => {
        onUpdateIsActiveFilterItems(value === 'S' ? 'N' : 'S');
    };

    function changeShowFilterMonthPanel() {
        onUpdateShowFilterMonthPanelItem(false)
    }


    const styleComboBoxYear = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    }


    return (
        <MiddlePanel isVisible={showFilterMonthPanelItem}>
            <Panel style={{
                width: '300px',
                height: '200px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5;',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Filtro dos itens'}
                    style={panelListStyle}
                    canViewCRUD={true}
                    cancelFunction={changeShowFilterMonthPanel}
                    cancelNameButton='Fechar'
                    recordsSelected={[]}
                    updating={true}
                    canSaveAfterEdit={false}>
                    <Panel style={styleButtonsMonth}>
                        <div style={styleRowsAttributes}>
                            <div id='attribute-control'>
                                <span className='span-role-control'>Somente ativos</span>
                                <InputField
                                    setAttribute={handleCheckboxChangeIeActiveValue}
                                    value={isActiveFilterItems}
                                    checked={isActiveFilterItems === 'S'}
                                    readOnly={false}
                                    disabled={false}
                                    type="checkbox"
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                            <div id='attribute-control'>
                                <span className='span-role-control'>Ano</span>
                                <ReactDataPickerComp
                                    selected={comboBoxYear}
                                    onChange={(date) => { onUpdateComboBoxYear(date) }}
                                    wrapperClassName={'width-full'}
                                    className='cost-spreedsheet-width-date cursor-pointer'
                                    showMonthYearPicker={true}
                                    dateFormat={'yyyy'}
                                    showYearPicker={true}
                                    setter={onUpdateComboBoxYear}
                                />
                            </div>
                        </div>

                    </Panel>
                </Panel>
            </Panel>
        </MiddlePanel >
    );
}

export default FilterItemCost;
